import { useAuth0 } from '@auth0/auth0-react';
import { CircularProgress, IconButton, TableContainer } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Pagination from '@material-ui/lab/Pagination';
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import sortImg from 'assets/icons/sort-able-svg.svg';
import Action from 'components/ActionPopOver';
import AlertDialog from 'components/Dialog/index';
import Loader from 'components/loader/Loader';
import SearchComp from 'components/Searchcomponent';
import TableColumnFilter from 'components/TableColumnFilter/TableColumnFilter';
import { formatDate } from 'helper/dateFormat';
import PreSchoolService from 'Lib/API/PreSchool/index';
import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { useHistory } from 'react-router-dom';
import { archiveOptions } from '../bulkClassConstant';
import { fontConfig } from "theme/fontConfig";

const TableCellHead = withStyles((theme) => ({
  root: {
    height: '39px',
    padding: '0px 20px',
    borderBottom: 'none',
    fontFamily: fontConfig.GeneralTableCellHeadFont.family,
  },
}))(TableCell);

const TableCellBody = withStyles((theme) => ({
  root: {
    height: '65px',
    padding: '0px 20px',
    fontFamily: fontConfig.GeneralTableCellBodyFont.family,
  },
}))(TableCell);



const BulkClassList = () => {
  const { getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch()
  const history = useHistory();

  const [searchValue, setSearchValue] = useState('');
  const [page, setPage] = useState(1);

  const [list, setList] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sorting, setSorting] = useState({
    sort: {},
    search: undefined,
  });
  const [selectedFilter, setSelectedFilter] = useState("no")
  const [openConfirmModal, setOpenConfirmModal] = useState({
    open: false,
    message: '',
    isLoading: false,
    id: null,
    type: null,
  });

  const organization = localStorage.getItem('organization')
    ? JSON.parse(localStorage.getItem('organization'))
    : null;
  const orgKey = organization?.orgkey;



  const mainUrl = window.location.origin;
  const getLink = (id) => {
    const checkDomain =
      mainUrl === 'https://admin.eztmpl.dev' ||
        mainUrl === 'http://localhost:3000'
        ? `https://shalom.eztmpl.dev/school/bulk/${id}`
        : mainUrl === 'https://admin.eztmpl.com'
          ? `https://demo.eztmpl.com/school/bulk/${id}`
          : mainUrl === 'https://admin.easyshul.com'
            ? `https://${orgKey}.easyshul.com/school/bulk/${id}`
            : mainUrl === 'https://admin-green.easyshul.com' ? `https://localhost.member-green.easyshul.com/school/bulk/${id}` : null;
    return checkDomain
  }
  const previewBulkClass = (id) => {
    const link = getLink(id);
    window.open(link, '_blank');
  };



  const getBulkClassList = async (initialPage) => {
    const currentPage = initialPage || page;
    if (currentPage === 1) {
      setPage(1);
    }
    setLoading(true);

    const payload = {
      ...sorting,
      ...(selectedFilter ? {
        filter: {
          archived: selectedFilter,
        }
      } : {}),
    }
    try {
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.getBulkClassesList(
        token,
        sorting?.search ? 1 : currentPage,
        30,
        payload
      );
      setList(result?.payload?.data);
      setCount(result?.payload?.pagination?.count);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong!');
    } finally {
      setLoading(false);
    }
  }



  useEffect(() => {
    if (selectedFilter) {
      debounceCall();
    } else {
      getBulkClassList(1);
    }
    return () => debounceCall.cancel();
  }, [sorting, selectedFilter]);


  const debounceCall = useCallback(
    debounce(() => {
      if (selectedFilter) {
        getBulkClassList(1);
      }
    }, 500),
    [selectedFilter, sorting]
  );


  useEffect(() => {
    if (searchValue === '') {
      setSorting({ ...sorting, search: undefined });
    } else {
      setSorting({ ...sorting, search: searchValue });
    }
  }, [searchValue]);


  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const regex = /[\*\(\)\+]/;

    if (!regex.test(inputValue)) {
      setSearchValue(inputValue);
    }
  };

  const handleSort = (name) => {
    setSorting((prev) => ({
      ...prev,
      sort: {
        [name]: prev.sort[name] === 1 ? -1 : 1,
      }
    }));
  };

  const onEventTypeFilterChange = (name, value) => {
    if (value === selectedFilter) {
      setSelectedFilter("")
    } else {
      setSelectedFilter(value)
    }
  }

  const duplicateBulkClassHandler = (id) => {
    setOpenConfirmModal((prev) => ({
      ...prev,
      open: true,
      message: 'Do you want to duplicate this bulk registration?',
      isLoading: false,
      id: id,
      type: 'duplicate',
    }));
  }

  const archiveBulkClassHandler = (id, type = 'archive') => {
    setOpenConfirmModal((prev) => ({
      ...prev,
      open: true,
      message: `Do you want to ${type === 'archive' ? 'archive' : 'active'} this bulk registration?`,
      isLoading: false,
      id: id,
      type,
    }));
  }
  const deleteBulkClassHandler = (id) => {
    setOpenConfirmModal((prev) => ({
      ...prev,
      open: true,
      message: 'Do you want to delete this bulk registration?',
      isLoading: false,
      id: id,
      type: 'delete',
    }));
  }

  const closeConfirmModal = () => {
    setOpenConfirmModal((prev) => ({
      ...prev,
      open: false,
      message: '',
      isLoading: false,
      id: null,
      type: null,
    }));
  }

  const duplicateHandler = async () => {
    const payload = {
      bulkClassId: openConfirmModal?.id,
    };
    try {
      setOpenConfirmModal((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const token = await getAccessTokenSilently();
      await PreSchoolService.duplicateBulkClass(token, payload);
      toastr.success('Success', 'Bulk Registration duplicated successfully');
      closeConfirmModal();
      getBulkClassList(1);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong!');
    } finally {
      closeConfirmModal();
    }
  }

  const archiveHandler = async () => {
    const payload = {
      id: openConfirmModal?.id,
      status: openConfirmModal?.type === 'archive' ? true : false,
    };
    try {
      setOpenConfirmModal((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const token = await getAccessTokenSilently();
      await PreSchoolService.archiveBulkClass(
        token,
        payload
      );
      toastr.success('Success', `Bulk Registration ${openConfirmModal?.type === 'archive' ? 'archived' : 'activated'} successfully`);
      closeConfirmModal();
      getBulkClassList(1);

    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong!');
    } finally {
      closeConfirmModal();
    }
  }

  const deleteHandler = async () => {
    try {
      setOpenConfirmModal((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const token = await getAccessTokenSilently();
      await PreSchoolService.deleteBulkClass(
        token,
        openConfirmModal?.id
      );
      toastr.success('Success', 'Bulk Registration deleted successfully');
      closeConfirmModal();
      getBulkClassList(1);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong!');
    } finally {
      closeConfirmModal();
    }
  }


  return (
    <div
      className="w-100 school_class_list"
    >
      <div className="current-class-table-container">
        <div className="header mt-5">
          <div
            style={{
              display: 'flex',
              padding: '20px 0px 10px 20px',
              alignItems: 'center',
              marginBottom: '18px',
            }}
            className="header__options"
          >
            <span className="finance-filter-serach-bar ">
              <SearchComp
                value={searchValue}
                setSearchText={handleInputChange}
                placeholder="Search"
                style={{ width: "20.5rem", backgroundColor: "#fff" }}
              />
            </span>
          </div>
        </div>
        <div style={{ paddingLeft: '17px', paddingRight: '17px' }}>
          <TableContainer className="scroll-table">
            <Table aria-label="collapsible table ">
              <TableHead className="charges-table sticky-table-header">
                <TableRow>
                  <TableCellHead className="class__header__cell className_head">
                    <div>
                      Bulk Registration Name
                      <IconButton>
                        <img
                          onClick={() => handleSort('bulkName')}
                          src={sortImg}
                          alt="sort"
                        />
                      </IconButton>
                    </div>
                  </TableCellHead>
                  <TableCellHead
                    align="left"
                    className="class__header__cell year__head"
                  >
                    <div>
                      Start Date
                      <IconButton>
                        <img
                          onClick={() => handleSort('bulkStartDate')}
                          src={sortImg}
                          alt="sort"
                        />
                      </IconButton>
                    </div>
                  </TableCellHead>
                  <TableCellHead
                    align="left"
                    className="class__header__cell year__head"
                  >
                    <div>
                      End Date
                      <IconButton>
                        <img
                          onClick={() => handleSort('bulkEndDate')}
                          src={sortImg}
                          alt="sort"
                        />
                      </IconButton>
                    </div>
                  </TableCellHead>
                  <TableCellHead
                    align="left"
                    className="class__header__cell"
                  >
                    <div className="d-flex h-100 justify-content-start align-items-center" style={{ gap: "10px" }}>
                      Archive
                      <TableColumnFilter
                        options={archiveOptions}
                        onChange={(value) => onEventTypeFilterChange("archive", value)}
                        value={selectedFilter}
                      // allSelected={s}
                      />
                    </div>
                  </TableCellHead>

                  <TableCellHead
                    align="left"
                    className="class__header__cell sticky-header-column"
                  />
                </TableRow>
              </TableHead>
              <TableBody
                style={{
                  backgroundColor: 'white',
                }}
              >
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <div
                        className="user__loader"
                        style={{ height: '320px' }}
                      >
                        <Loader />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : list?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <h6 style={{ height: '320px', marginTop: '100px' }}>
                        No Bulk Registration Found
                      </h6>
                    </TableCell>
                  </TableRow>
                ) : (
                  list?.map((row, i) => (
                    <React.Fragment>
                      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                        <TableCellBody
                          className="status-head main-width-class"
                          component="th"
                          scope="row"

                        >
                          <div className="school-table-registration text-nowrap">
                            {row?.bulkName}
                          </div>
                        </TableCellBody>
                        <TableCellBody
                          className="account-header main-width-class"
                          align="left"

                        >
                          <div className="school-table-registration text-nowrap">
                            {formatDate({ date: row?.bulkStartDate, formatType: "default" })}
                          </div>
                        </TableCellBody>
                        <TableCellBody
                          className="account-header main-width-class"
                          align="left"

                        >
                          <div className="school-table-registration text-nowrap">
                            {formatDate({ date: row?.bulkEndDate, formatType: "default" })}
                          </div>
                        </TableCellBody>
                        <TableCellBody
                          className="account-header main-width-class"
                          align="left"
                        >
                          <div className="school-table-registration text-nowrap">
                            {row?.archived ? (
                              <CheckCircleIcon color="primary" />
                            ) : (
                              <CancelIcon color="primary" />
                            )}
                          </div>
                        </TableCellBody>
                        <TableCellBody
                          className="exp-action-head main-width-class sticky-body-column"
                          align="right"
                        >
                          <div
                            style={{ cursor: 'pointer', paddingleft: '0px' }}
                          >
                            <Action
                              action="class"
                              style={{ width: '16px' }}

                              onRegistrationLinkClick={() => previewBulkClass(row?._id)}
                              disabledOnRegistrationLink={row?.archived}

                              onEditClick={() => {
                                history.push(`/edit-bulk-class/${row?._id}`)
                              }}

                              onDuplicateClick={() => {
                                duplicateBulkClassHandler(row?._id);
                              }}

                              onArchiveClick={!row?.archived ? () => {
                                archiveBulkClassHandler(row?._id, 'archive');
                              } : null}

                              onActiveClick={row?.archived ? () => {
                                archiveBulkClassHandler(row?._id, 'active');
                              } : null}

                              onClassDeleteClick={() => {
                                deleteBulkClassHandler(row?._id);
                              }}
                            />
                          </div>
                        </TableCellBody>
                      </TableRow>
                    </React.Fragment>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className="pagination-custom mt-9">
          <Pagination
            count={Math.ceil(count / 30)}
            color="primary"
            variant="outlined"
            page={page}
            onChange={(event, value) => {
              setPage(value);
              getBulkClassList(value);
            }}
          />
        </div>
      </div>
      <AlertDialog
        open={openConfirmModal?.open}
        onDecline={() => {
          closeConfirmModal();
        }}
        onAccept={() => {
          if (openConfirmModal?.type === 'duplicate') {
            duplicateHandler();
          }
          if (openConfirmModal.type === 'archive' || openConfirmModal.type === 'active') {
            archiveHandler();
          }
          if (openConfirmModal.type === 'delete') {
            deleteHandler();
          }
        }}
        title={'Are you sure?'}
        description={openConfirmModal?.message}
        disabled={openConfirmModal?.isLoading}
      />
    </div>
  )
}


export default BulkClassList